"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSchemaIdentifier = exports.getSingleLineSchemaIdentifier = void 0;
var getStringifiedFieldValueFromSchema_1 = require("./getStringifiedFieldValueFromSchema");
/**
 * Schema identifiers are split in two parts: title and subtitle
 * This function combines both and returns a single string to meet specific ui requirements
 */
function getSingleLineSchemaIdentifier(data, schema) {
    var identifier = schema.identifier;
    var title = identifier
        ? identifier.title
            .map(function (propertyKey) { return (0, getStringifiedFieldValueFromSchema_1.getStringifiedFieldValueFromSchema)(propertyKey, schema, data); })
            .filter(Boolean)
            .join(' ')
        : '-';
    var subtitle = identifier
        ? identifier.subtitle
            .map(function (propertyKey) { return (0, getStringifiedFieldValueFromSchema_1.getStringifiedFieldValueFromSchema)(propertyKey, schema, data); })
            .filter(Boolean)
            .join(' ')
        : '';
    return title + " " + (subtitle ? "- (" + subtitle + ")" : '');
}
exports.getSingleLineSchemaIdentifier = getSingleLineSchemaIdentifier;
function getSchemaIdentifier(data, schema) {
    var identifier = schema.identifier;
    var title = identifier
        ? identifier.title
            .map(function (propertyKey) { return (0, getStringifiedFieldValueFromSchema_1.getStringifiedFieldValueFromSchema)(propertyKey, schema, data); })
            .filter(Boolean)
            .join(' ')
        : '';
    var subtitle = identifier
        ? identifier.subtitle
            .map(function (propertyKey) { return (0, getStringifiedFieldValueFromSchema_1.getStringifiedFieldValueFromSchema)(propertyKey, schema, data); })
            .filter(Boolean)
            .join(' ')
        : '';
    return {
        title: title,
        subtitle: subtitle,
    };
}
exports.getSchemaIdentifier = getSchemaIdentifier;
